export default __webpack_public_path__ + "static/media/Eb2.af3dd0e0.mp3";